import * as React from 'react';

import {Card} from 'shells/card/card';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import WebFXLogo from 'shells/logos/webfx-logo.svg';

import {IntercomLaunchButton} from '../../intercom';

import styles from './mcfx-subscription-info.module.css';

export function McfxSubscriptionInfo() {
    return (
        <div className={styles['mcfx-subscription-info']}>
            <Card hasBorder={true} fitContent={true}>
                <div className={styles.content}>
                    <EmptyStateSmall
                        icon={<WebFXLogo />}
                        title='🥳 Your Nutshell account is included with your RevenueCloudFX
                             subscription'
                        subtitle={
                            <div>
                                If you’d like to make changes{' '}
                                <IntercomLaunchButton
                                    size='big'
                                    variant='text-primary'
                                    noPadding={true}
                                >
                                    contact us
                                </IntercomLaunchButton>
                                , or talk with your WebFX Account Manager .
                            </div>
                        }
                    />
                </div>
            </Card>
        </div>
    );
}
